const ApiResources = Object.freeze({
  events: {
    detail: '/events/exists/%s'
  }
});

export default ApiResources;
export const AXIOS_SYSTEM_ERROR_CODE = ['ECONNREFUSED', 'EHOSTUNREACH', 'ECONNRESET', 'ECONNABORTED', 'EHOSTDOWN', 'ENETDOWN', 'ENETRESET', 'ENETUNREACH', 'ETIMEDOUT'];
